var React = require('react');

function Female (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.3512 14.2844C13.7538 14.2844 15.099 13.7272 16.0909 12.7354C17.0827 11.7436 17.6399 10.3984 17.6399 8.99572C17.6399 7.59307 17.0827 6.24787 16.0909 5.25605C15.099 4.26423 13.7538 3.70703 12.3512 3.70703C10.9485 3.70703 9.60334 4.26423 8.61152 5.25605C7.6197 6.24787 7.0625 7.59307 7.0625 8.99572C7.0625 10.3984 7.6197 11.7436 8.61152 12.7354C9.60334 13.7272 10.9485 14.2844 12.3512 14.2844ZM12.3512 14.2844V20.6301M9.17788 17.4568H15.5245","stroke":"white","strokeWidth":"1.37214","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Female.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Female;

Female.default = Female;
